import { createSelector } from '@ngrx/store';
import { State } from 'reducers';

export const selectUI = (state: State) => state.ui;

export const selectPrintMode = createSelector(selectUI, uiState => uiState.printMode);
